'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerImageContainer = renderWithRef('BannerImageContainer', null, (n, a)=>{
    let { children: o } = n;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: a,
        classNames: [
            'swan-banner-image-container'
        ],
        props: n,
        children: o
    });
});

export { BannerImageContainer };
